import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import { slices } from 'src/features'
import affiliateCenter from 'src/features/affiliate-center/slice'

export function makeStore() {
  return configureStore({
    reducer: {
      admin: slices.adminReducer,
      affiliateCenter,
      auth: slices.authSlice,
      cabifyProcess: slices.cabifyProcessSlice,
      companies: slices.companySlice,
      compensation: slices.compensationReducer,
      countrySlice: slices.countrySlice,
      currencies: slices.currencySlice,
      deposits: slices.depositsSlice,
      footprint: slices.footprintSlice,
      messages: slices.messagesSlice,
      myIntegration: slices.myIntegrationSlice,
      myOrders: slices.myOrdersSlice,
      offers: slices.offerSlice,
      offsetReasons: slices.offsetReasons,
      projectOptions: slices.projectOptions,
      projects: slices.projectSlice,
      saleOffers: slices.saleOffersSlice,
      sales: slices.salesSlice,
      sdgCompliances: slices.sdgCompliancesSlice,
      stockAlerts: slices.stockAlertsSlice,
      summary: slices.summarySlice,
      transactions: slices.transactionSlice,
      users: slices.userReducer,
      visitors: slices.visitorSlice,
      vouchers: slices.voucherSlice
    },
  })
}

const store = makeStore()

export type AppState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AppState,
  unknown,
  Action<string>
>

export default store
